import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getSelectedCrew, getSelectedPackageData } from '../helpers/week';
import history from '../history';
import { getYachtDescription } from '../helpers/category';
import { Button, Divider, Pill } from 'day8-ui';
import { useToolipModal } from '../context/TooltipModalContext';
import { getCabinIncludedText } from '../helpers/booking';
import HeaderItem from './HeaderItem';
import RatingsWidget from './ratings/RatingsWidget';


const YachtCardHeader = ({
  className, dividerComponent, title, years, bathrooms, maxCapacity, maxCapacityTooltipText, length, hasAircon, hullType, suitablePackageIds = [], crew, cabinCrew, packageData, week, hideIcons, pill, description, feedbackStats
}) => {
  const { openTooltipModal } = useToolipModal();
  const destinations = useSelector(state => state.destinations.items);
  const selectedCrew = crew || getSelectedCrew(destinations, history.location);
  const selectedCategory = packageData || getSelectedPackageData(destinations, history.location);
  const airconTooltipText = 'Air conditioning on a yacht is not of the same standard you may be used to on land! AC on board is designed to be used when docked in the evenings and whilst sleeping. The cooling ability is not as powerful as AC found on land and when used continuously during the day the chance of malfunction increases. During the day, jump up on top deck and enjoy the sea breeze!';
  const headerObjects = [{
    icon: 'time-outline', title: 'Yacht Age:', subTitle: years, hasTooltip: false, tooltipText: '', border: { right: true, mobileRight: true, mobileBottom: true }, mobileBottomLength: false
  }, {
    icon: 'shower', title: 'Bathrooms:', subTitle: bathrooms || '2+', hasTooltip: false, tooltipText: '', border: { right: true, mobileRight: true, mobileBottom: true }, mobileBottomLength: false
  }, {
    icon: 'bed', title: 'Sleeps:', subTitle: `${maxCapacity} guests`, hasTooltip: true, tooltipText: maxCapacityTooltipText, border: { right: true, mobileRight: false, mobileBottom: true }, mobileBottomLength: false
  }, {
    icon: 'ruler', title: 'Length:', subTitle: `${length}ft`, hasTooltip: false, tooltipText: '', border: { right: true, mobileRight: true, mobileBottom: false }, mobileBottomLength: true
  }, {
    icon: 'ac', title: 'A/C:', subTitle: `${hasAircon ? 'yes' : 'no'}`, hasTooltip: true, tooltipText: airconTooltipText, border: { right: false, mobileRight: false, mobileBottom: false }, mobileBottomLength: true
  }];

  let updatedDescription = description || getYachtDescription(selectedCategory?.id, maxCapacity, selectedCrew.hostess, length, hullType, hasAircon, suitablePackageIds);
  if (cabinCrew) {
    updatedDescription = getCabinIncludedText(null, week, selectedCategory, cabinCrew);
  }
  return (
    <div className={className} id="yacht-card-header">
      {title && <h2 className="dui-text-2xl">{title}</h2>}
      {feedbackStats && (
        <div className='dui-flex dui-flex-col dui-gap-2 dui-mt-4'>
          <RatingsWidget rating={feedbackStats?.category_ratings.yacht} />
          <p className='dui-text-sm dui-text-gray-400'>Based on <strong>{feedbackStats.total_count}</strong> reviews from previous Yacht Week guests</p>
        </div>
      )}
      {pill && <Pill className="dui-mt-4 dui-bg-secondary-500">{pill}</Pill>}
      {updatedDescription && (<p className="dui-mt-4 dui-flex dui-items-center dui-gap-2">{updatedDescription}</p>)}
      {!hideIcons && (
        <>
          {dividerComponent ? dividerComponent : <Divider className='dui-my-8' />}
          <div className='dui-grid dui-grid-cols-3 md:dui-grid-cols-5 dui-justify-center dui-gap-y-5'>
            {headerObjects.map(item => {
              return (
                <div key={JSON.stringify(item)} className='dui-border-solid md:dui-border-l-[1px] first:dui-border-l-0 dui-border-gray-200'>
                  {item.hasTooltip? (
                    <Button className='dui-w-full' buttonType='LINK' onClick={() => openTooltipModal(item)}>
                      <HeaderItem icon={item.icon} title={item.title} subTitle={item.subTitle} hasTooltip={item.hasTooltip} />
                    </Button>
                  ) : (
                    <HeaderItem icon={item.icon} title={item.title} subTitle={item.subTitle} hasTooltip={item.hasTooltip} />
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
YachtCardHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  years: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxCapacityTooltipText: PropTypes.string,
  bathrooms: PropTypes.number,
  maxCapacity: PropTypes.number,
  hasAircon: PropTypes.bool,
  pricePerPerson: PropTypes.number,
  baseCurrency: PropTypes.bool,
  hullType: PropTypes.string,
  suitablePackageIds: PropTypes.array
};
export default YachtCardHeader;